import { firebaseAuth } from '../firebase'
import * as authActions from './actions'
export { authActions }

export * from './action-types'
export * from './reducer'

export function initAuth(dispatch) {
  return new Promise((resolve, reject) => {
    const unsub = firebaseAuth.onAuthStateChanged(
      user => {
        dispatch(authActions.initAuth(user))
        unsub()
        resolve()
      },
      error => reject(error)
    )
  })
}

export const getUserEmail = state => state.auth.email;
export const getUserName = state => state.auth.name;
export const getAuthError = state => state.auth.error;

export function getAuthToken() {
  return firebaseAuth.currentUser.getToken(true)
}



// WEBPACK FOOTER //
// ./src/modules/auth/index.js